import { useEffect, useState } from 'react';

import Modal from 'components/Modal/Modal';

import { usePostBookingSurveyApi } from 'hooks/appointment/usePostBookingSurveyApi';

import { TAppointmentContact } from 'types/appointment';

import { PostBookingSurveyConfirmation } from './PostBookingSurveyConfirmation';
import { PostBookingSurveyForm } from './PostBookingSurveyForm';
import { usePostBookingSurveyEvents } from './usePostBookingSurveyEvents';

import s from './PostBookingSurvey.module.css';

type Props = {
  hasForms?: boolean;
  clientInfo: Pick<TAppointmentContact, 'firstName' | 'email' | 'phone'>;
};

export const PostBookingSurvey = ({ hasForms, clientInfo }: Props) => {
  const { data: survey, submitResponse } = usePostBookingSurveyApi(
    clientInfo.email,
    clientInfo.phone,
  );
  const { trackOriginSurvey, trackClose, trackSubmit } =
    usePostBookingSurveyEvents();

  useEffect(trackOriginSurvey, []); // eslint-disable-line react-hooks/exhaustive-deps

  const [modalOpen, setModalOpen] = useState(true);
  const [completed, setCompleted] = useState(false);

  function onSubmit(category: string, answer: string, finish: boolean) {
    const token = survey!.token; // eslint-disable-line @typescript-eslint/no-non-null-assertion
    const categoryPatch = category || 'Other';
    const responseObj = { category: categoryPatch, answer };

    void submitResponse(token, responseObj).catch(console.error);

    if (finish) {
      const answerOptions = survey!.categories.reduce<string[]>( // eslint-disable-line @typescript-eslint/no-non-null-assertion
        (acc, c) => (c.type === 'text' ? [...acc] : [...acc, ...c.options]),
        [],
      );

      const detail = answerOptions.includes(answer) ? answer : '';

      trackSubmit(categoryPatch, detail);
      setCompleted(true);
    }
  }

  function onCloseModal() {
    trackClose();
    setModalOpen(false);
  }

  if (!modalOpen || !survey) return <></>;

  return completed ? (
    <Modal
      showClose={false}
      className={s.modal}
      title={`Thank you ${clientInfo.firstName}!`}
      aria-label={`Thank you ${clientInfo.firstName}!`}
    >
      <div className={s.rootContainer}>
        <PostBookingSurveyConfirmation
          hasForms={hasForms}
          onConfirm={onCloseModal}
        />
      </div>
    </Modal>
  ) : (
    <Modal
      showClose={false}
      className={s.modal}
      aria-labelledby="postbooking-survey-modal"
    >
      <div className={s.rootContainer}>
        <PostBookingSurveyForm
          schema={survey}
          onSubmit={onSubmit}
          onClose={onCloseModal}
          ariaLabels="postbooking-survey-modal"
        />
      </div>
    </Modal>
  );
};
